export default __webpack_public_path__ + "static/media/charger.4bb2f928.png";